export function initHeaderInfo() {
    if (!document.querySelector('.header-top-info-bar')) return;

    function updateDateTime() {
        const now = new Date();
        const days = ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'];
        const formatted = `${now.getDate().toString().padStart(2, '0')}.${(now.getMonth() + 1).toString().padStart(2, '0')}.${now.getFullYear()}, ${days[now.getDay()]} ${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;
        document.getElementById('currentDateTime').textContent = formatted;
    }

    function getArrowAndColor(current, previous) {
        if (current > previous) return '<span>&#9650;</span>';
        if (current < previous) return '<span>&#9660;</span>';
        return '';
    }

    function isCurrentDate(date) {
        const today = new Date();
        const dataDate = new Date(date);
        return today.toDateString() === dataDate.toDateString();
    }

    async function updateCurrencyRates() {
        try {
            const response = await fetch('https://www.cbr-xml-daily.ru/daily_json.js');
            const data = await response.json();

            if (!isCurrentDate(data.Date)) {
                console.warn('Курсы валют не обновлены ЦБ РФ');
            }

            document.getElementById('usdRate').innerHTML = `USD: ${data.Valute.USD.Value.toFixed(2)} ${getArrowAndColor(data.Valute.USD.Value, data.Valute.USD.Previous)}`;
            document.getElementById('eurRate').innerHTML = `EUR: ${data.Valute.EUR.Value.toFixed(2)} ${getArrowAndColor(data.Valute.EUR.Value, data.Valute.EUR.Previous)}`;
        } catch (error) {
            console.error('Ошибка получения курсов валют:', error);
        }
    }

    document.addEventListener('DOMContentLoaded', () => {
        updateDateTime();
        updateCurrencyRates();
        setInterval(updateDateTime, 1000);
        setInterval(updateCurrencyRates, 300000);
    });
}
